






























































































































































import Bugsnag from '@bugsnag/js';
import axios from 'axios';
import EventBus from '@/eventBus';
import i18n from 'vue-i18n';
import { get } from 'lodash';
import CoManagePaymentMethodsInCheckout from '../Molecules/co-manage-payment-methods-in-checkout/CoManagePaymentMethodsInCheckout.vue';
import CoCardBillingAddress from '../Organisms/co-card-billing-address/CoCardBillingAddress.vue';
import CoHeadline from '../Atoms/co-headline/CoHeadline.vue';
import CoCard from '../Molecules/co-card/CoCard.vue';

export default {
    i18n: {
        messages: {
            en: {
                upgradepolicy:
                    'Plan upgrades will take place immediately. You will receive a refund for the remaining days of the current plan.',
            },
            de: {
                upgradepolicy:
                    'Tarif-Upgrades werden sofort durchgeführt. Du erhältst eine Rückerstattung für die verbleibenden Tage des aktuellen Tarifs.',
            },
        },
    },
    name: 'ChangePlanReview',
    components: {
        CoManagePaymentMethodsInCheckout,
        CoCardBillingAddress,
        CoHeadline,
        CoCard,
    },
    props: {
        plan: {
            type: Object,
            default: null,
        },
        selected: {
            type: Array,
            default: () => [],
        },
        user: {
            type: Object,
            default: null,
        },
        coupon: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            AcceptTermsAndConditions: false,
            TermsAndConditions: null,
            loading: false,
            me: this.$store.state.me,
            billingAddress: {} as object | null,
        };
    },
    computed: {
        isReady() {
            return this.AcceptTermsAndConditions;
        },
    },
    mounted() {
        // assign billing address from store
        this.billingAddress = this.me?.Address || {};
        if (!this.user) {
            this.getTermsAndConditions();
        } else {
            this.AcceptTermsAndConditions = true;
        }
    },
    methods: {
        get,
        back() {
            this.$emit('prevStep');
        },
        changePlan() {
            this.$emit('changePlan');
        },
        calculatePrice(extra) {
            if (extra.TaxRateID === '' || extra.TaxRate.Inclusive) {
                const price = extra.PriceInCents / 100.0;
                return price;
            }
            const price = extra.PriceInCents / 100.0;
            const totalPrice = price * (extra.TaxRate.Percentage / 100 + 1);
            return totalPrice;
        },
        totalPrice() {
            let total = this.calculatePrice(this.plan);
            if (this.selected) {
                this.selected.forEach((element) => {
                    total += this.calculatePrice(element);
                });
            }

            if (this.coupon) {
                if (this.coupon.AmountOff > 0) {
                    total -= this.coupon.AmountOff / 100;
                } else if (this.coupon.PercentageOff != 0.0) {
                    total *= 1 - this.coupon.PercentageOff / 100;
                }

                if (total < 0) {
                    total = 0;
                }
            }
            return total.toFixed(2);
        },
        getTermsAndConditions() {
            axios({
                method: 'GET',
                url: '/space/get-terms-and-conditions',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.TermsAndConditions = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        saveBillingAddressData(billingAddress) {
            this.billingAddress = billingAddress;
            const data = { Address: billingAddress };
            return new Promise<void>((resolve, reject) => {
                axios({
                    method: 'PUT',
                    url: '/dashboard/me-billing',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data,
                })
                    .then((response) => {
                        EventBus.$emit('INFO', { Message: this.$t('messages.changessaved') });
                        this.billingAddress = billingAddress;
                    })
                    .catch((error) => {
                        console.log(error);
                        Bugsnag.notify(error);

                        if (get(error, 'response.data', '').match('tax_id_invalid')) {
                            EventBus.$emit('ERROR', {
                                Message: `${this.$t('labels.vatid')} ${this.$t('errors.invalid')}`,
                            });
                        } else {
                            EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                        }
                    })
                    .finally(() => {
                        resolve();
                    });
            });
        },
    },
};
